export const Table = {
  data () {
    return {
      tableData: [],
      loading: false,
      contentDialogVisible: false,
      searchDialogVisible: false,
      formRef: 'contentInfoForm',
      searchInfo: {},
      contentInfo: {},
      selectIds: [],
      pageInfo: {
        page: 1,
        total: 0,
        size: 10
      }
    }
  },
  mounted () {
    let autoSearch = this.beforeTableSearch()
    if (autoSearch) {
      this.searchList()
    }
  },
  methods: {
    beforeTableSearch() {
      return true
    },
    searchMethod () {},
    beforeAdd () {},
    addMethod () {},
    beforeUpdate () {},
    updateMethod () {},
    deleteMethod (id) {},
    batchDeleteMethod () {},
    handleSearchDialog () {
      this.searchDialogVisible = true
    },
    handleSearch () {
      this.pageInfo.page = 1
      this.searchList()
    },
    searchList () {
      this.loading = true
      this.searchMethod().then(res => {
        this.loading = false
        this.searchDialogVisible = false
        if(res.data.code===0){
          this.tableData = res.data.data.list
          this.pageInfo.total = res.data.data.total
        }else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(err => {
        this.searchDialogVisible = false
        this.loading = false
      })
    },
    handleSelectionChange (val) {
      this.selectIds = []
      val.forEach(element => {
        this.selectIds.push(element.id)
      })
    },
    handleBatchDelete () {
      if (this.selectIds.length>0) {
        this.$confirm('确认要删除选择项', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.batchDeleteMethod().then(res => {
            if (res.data.code === 0) {
              this.searchList()
            }else {
              this.$message({
                type: 'error',
                message: '删除失败'
              })
            }
          })
        })
      }
    },
    handleAdd () {
      this.contentInfo = {}
      this.beforeAdd()
      this.contentDialogVisible = true
      if (this.$refs[this.formRef]) {
        this.$refs[this.formRef].clearValidate()
      }
    },
    handleEdit (index, row) {
      this.contentInfo = Object.assign({},row)
      this.beforeUpdate()
      this.contentDialogVisible = true
      if (this.$refs[this.formRef]) {
        this.$refs[this.formRef].clearValidate()
      }
    },
    handleDel (index, row){
      let name = row.name
      if (!name) {
        name = row.title
      }
      this.$confirm('确认要删除' + name, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteMethod(row.id).then(res => {
          if (res.data.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.searchList()
          } else {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          }
        })
      })
    },
    valForm () {
      let isValid = true
      this.$refs[this.formRef].validate((valid) => {
        if (!valid) {
          isValid = false
        }
      })
      if (!isValid) {
        this.$message({
          showClose: true,
          message: '请检查填写内容',
          type: 'error'
        })
      }
      return isValid
    },
    handleSave () {
      let isValid = this.valForm()
      if (!isValid) {
        return
      }
      if(this.contentInfo.id){
        this.updateMethod(this.contentInfo).then(res => {
          if (res.data.code === 0) {
            this.contentDialogVisible = false
            this.searchList()
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      }else {
        this.addMethod(this.contentInfo).then(res => {
          if (res.data.code === 0) {
            this.contentDialogVisible = false
            this.searchList()
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    handleSizeChange (val) {
      this.pageInfo.size = val
      this.searchList()
    },
    handleCurrentChange (val) {
      this.pageInfo.page = val
      this.searchList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Table.js